import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, watch, onBeforeUnmount } from "vue";
import { AiEditor } from "aieditor";
import "aieditor/dist/style.css"


export default /*@__PURE__*/_defineComponent({
  __name: 'Editer',
  props: {
    modelValue: {
        type: String,
        default: ''
    }
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const editorEl = ref<HTMLElement | null>(null)
let editor: AiEditor | null = null

onMounted(() => {
    editor = new AiEditor({
        element: editorEl.value as Element,
        placeholder: "点击输入内容...",
        content: props.modelValue,
        toolbarKeys: ["undo", "redo", "brush", "eraser",
            "|", "heading", "font-family", "font-size",
            "|", "bold", "italic", "underline", "strike", "link", "code", "subscript", "superscript", "hr", "todo", "emoji",
            "|", "highlight", "font-color",
            "|", "align", "line-height",
            "|", "bullet-list", "ordered-list", "indent-decrease", "indent-increase",
        ],
        onChange: (ed: AiEditor) => {
            emit('update:modelValue', ed.getHtml())
        }
    })
})

watch(() => props.modelValue, (val) => {
    if (!editor) return
    const current = editor.getHtml()
    if (val !== current) {
        editor.setContent(val || '')
    }
})

onBeforeUnmount(() => {
    if (editor) {
        editor.destroy()
        editor = null
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      id: "aiEditor",
      ref_key: "editorEl",
      ref: editorEl,
      style: {"height":"550px"}
    }, null, 512)
  ]))
}
}

})